import { FC, useEffect, useRef, useState } from 'react';
// import { getIsLogin } from 'lowcode/utils/getIsLogin';
import Banner from '../Common/Banner';
import Refer, { ReferHandle } from '../Common/Referral';
import Terms from '../Common/Terms';
import Subscribe from '../Common/Subscribe';
import { PlanType } from '../index.d';
import MyBonus from './MyBonus';
import RankingList from './RankingList';
import RankingListNew from './RankingListNew';
// import HowWorks from './HowWorks';
import HowWorks from './HowWorksNew';
import Faq from './FAQ';
import styled from './index.module.scss';
import RewardsModal, { RewardsModalHandle } from './RewardsModal';
import MemberCard from './MemberCard';
import ProductGallery from './ProductGallery';
import { useReferralDispatch, useReferralStore } from '../ReferralProvider';
import { useGlobal } from '@/utils/useGlobal';
import Button from '@/components/UI/Button';
import EfModal from '@/components/UI/Modal';
import efBridge from '@/utils/JSBridge';
import getLocal from '@/app/utils/getLocal';
import { IPageStatus } from '@/components/Referral/config/IPageStatus';
import Intruction from './Introduction';
import UserStories from '../Common/UserStories';
import { EuropeSites } from '../util';
import gtm from '@/utils/gtm';
import { signupCookie } from 'eco-design-reliance/cookies/signupCookie';
import BannerV2 from '../CommonV2/Banner';
import MyRewards from '../CommonV2/MyRewards';
import Bonus from '../CommonV2/Bonus';
import RealUsers from '../CommonV2/RealUsers';
import ReferButton from '../CommonV2/ReferButton';
import { createPortal } from 'react-dom';

const ShareCompoment: FC<{ isLogin: boolean; pageStatus: IPageStatus }> = ({ isLogin, pageStatus }) => {
    const { useLang, useRouter, isApp } = useGlobal();
    const router = useRouter();
    const { locale, pathname } = getLocal();
    const { t } = useLang('referral');
    const [show, setShow] = useState(false);
    const [isClient, setIsClient] = useState(false);
    const referRef = useRef<ReferHandle>(null);
    const rewardsRef = useRef<RewardsModalHandle>(null);
    const dispatch = useReferralDispatch();
    const { referralInfo, inBlackList, pageUsing } = useReferralStore();
    // const isLogin = getIsLogin();
    const path = `/${locale}${pathname}`;

    useEffect(() => {
        let pageType = '';
        if (pathname === '/referral-delta-pro-3-portable-power-station') {
            pageType = 'dp3';
        }
        // 不然被覆盖了 紧急需求 先这样吧
        if (pathname === '/referral-delta-3-max-series') pageType = 'd3ms';

        dispatch({ type: 'changePageUsingInfo', payload: pageType });
        dispatch({ type: 'getReferralInfo', payload: { locale, path, newInterface: pageType === 'd3ms' } });
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    useEffect(() => {
        const { pop } = router.query;
        if (!referralInfo) return;
        if (!referralInfo.planId) {
            // 判断是否为app环境
            if (isApp) {
                setShow(true);
            } else {
                router.push(pageUsing === 'd3ms' ? `/${locale}/referral` : `/${locale}/ecocredits`);
            }
        }
        if (pop === 'rewards' && rewardsRef && !inBlackList) rewardsRef.current?.show();
        if (pop === 'share' && referRef && !inBlackList) referRef.current?.show();
        history.pushState('', '', location.href.replace(`?pop=${pop}`, ''));
    }, [referRef, referralInfo]);

    // 默认 /referral页面
    if (!pageUsing) {
        return (
            <>
                <style jsx global>
                    {`
                        .ant-message {
                            z-index: 9999999;
                        }
                        .ant-modal-root {
                            z-index: 2102;
                        }
                        .ant-modal-content {
                            border-radius: 12px !important;
                        }
                    `}
                </style>
                <div className={`${styled.share_compoment}`}>
                    <BannerV2 subtitle={referralInfo?.label || ''} title={referralInfo?.title || ''} desc={referralInfo?.subTitle || ''}>
                        <ReferButton lTheme="white" listenPopShare={true} />
                    </BannerV2>
                    <MyRewards />
                    <Bonus />
                    <RealUsers showReferButton={true} />
                    <Faq />

                    <div
                        className="terms-title"
                        onClick={() => {
                            window.open(`/${locale}/referral-terms`, '_blank');
                        }}
                    >
                        {t('terms.title')}
                    </div>
                    {/* <Terms /> */}
                </div>
            </>
        );
    }

    return (
        <>
            <style jsx global>
                {`
                    .ant-message {
                        z-index: 9999999;
                    }
                    .ant-modal-root {
                        z-index: 2102;
                    }
                    .ant-modal-content {
                        border-radius: 12px !important;
                    }
                `}
            </style>
            <div className={`${styled.share_compoment}`}>
                <Banner subtitle={referralInfo?.label || ''} title={referralInfo?.title || ''} desc={referralInfo?.subTitle || ''}>
                    <Button
                        className="refer-btn"
                        onClick={() => {
                            referRef.current?.show();
                            if (!isLogin) {
                                signupCookie({
                                    sector_name: referralInfo?.title,
                                    entry_position: 1,
                                });
                            }
                            try {
                                gtm.push({
                                    event: 'uaEvent',
                                    event_name: 'referral_button',
                                    position: referralInfo?.title || '',
                                    button_name: isLogin ? t('banner.btn3') : t('banner.btn1'),
                                });
                            } catch (e) {
                                console.log(e);
                            }
                        }}
                        loading={!referralInfo}
                        disabled={inBlackList}
                    >
                        {isLogin ? t('banner.btn3') : t('banner.btn1')}
                    </Button>
                </Banner>
                {isLogin && <MyBonus />}
                {pageUsing && pageUsing === 'dp3' && <ProductGallery />}
                {/* {referralInfo?.planType === PlanType.CAMPAIGN && !(pageUsing && pageUsing === 'dp3') && (
                    <MemberCard title={t('member.title')} subTitle={t('member.subTitle')} cta={t('member.button')} />
                )} */}
                <HowWorks onRefer={() => referRef.current?.show()} pageStatus={pageStatus} />
                {EuropeSites.includes(locale) && <Intruction />}
                <Refer ref={referRef} hide />
                {!(pageUsing && pageUsing === 'dp3') && !EuropeSites.includes(locale) && <RankingList />}
                {!(pageUsing && pageUsing === 'dp3') && EuropeSites.includes(locale) && <RankingListNew />}
                {EuropeSites.includes(locale) && (
                    <UserStories isLogin={isLogin} handleShare={() => referRef.current?.show()} shareKey="Share Page_Hear from Real Users" />
                )}
                <Faq />
                <Terms />
                {/* {!(pageUsing && pageUsing === 'dp3') && <Subscribe isShare={true} />} */}
                {isClient &&
                    !(pageUsing && pageUsing === 'dp3') &&
                    createPortal(<Subscribe isShare={true} />, document.querySelector('#Widgets-box-in2-right-id') || document.body)}
                {isLogin && <RewardsModal ref={rewardsRef} planId={referralInfo?.planId} />}
                <EfModal
                    width="560"
                    visible={show}
                    open={show}
                    className={`${styled.no_active_modal}`}
                    centered={true}
                    getContainer={true}
                    onCancel={() => setShow(false)}
                >
                    <div className="content">
                        <p className="msg">{t('activity_site_not_supported')}</p>
                        <Button className="btn" onClick={() => efBridge?.callHandler('closeWebView')}>
                            {t('button_ok')}
                        </Button>
                    </div>
                </EfModal>
            </div>
        </>
    );
};

export default ShareCompoment;
